export default __webpack_public_path__ + "static/media/H1018.3.1a4ff6cb.mp3";